import React from 'react';
import './aboutSection.css';
import AnimatedSection from '../../AnimatedSection';
import {Link} from 'react-router-dom'
const AboutSection = () => {
  return (
    <div className="about-section">
      <AnimatedSection
        x={0}
        y={50}
        amount={0.4}
      >
        <div className="about-section-title">
          <h2>Hakkımızda</h2>
        </div>
      </AnimatedSection>

      <AnimatedSection
        x={0}
        y={50}
        amount={0.4} 
      >
        <div className="about-section-text">
          <p>
          Üniversitemiz lojmanları, akademik ve sosyal beklentileri karşılayan modern ve konforlu yaşam alanları sunmaktadır. Misyonumuz,öğrencilerimiz,akademisyenlerimiz ve çalışanlarımız için huzurlu, güvenli ve verimli bir ortam sağlamaktır. Şehir gürültüsünden uzak, doğayla iç içe olan lojmanlarımız; sosyal tesisler, spor alanları ve yürüyüş parkurlarıyla zenginleştirilmiştir. 7/24 güvenlik, teknik destek ve sürekli bakım hizmetleriyle konfor ve güvenliği ön planda tutuyoruz. Ayrıca, akademik ve sosyal gelişimi destekleyen çeşitli etkinlikler düzenlenmektedir. Üniversite lojmanlarımız, sadece barınma alanı değil, sosyal ve kültürel ihtiyaçları karşılayan bir yaşam biçimi sunmaktadır.
          </p>
        </div>
      </AnimatedSection>

      <div className="about-section-more">
        <p>
          Hakkımızdanın tamamını görmek için lütfen <Link s to="/hakkimizda"><b>tıklayınız.</b></Link>
        </p>
      </div>
    </div>
  );
};

export default AboutSection;
